import { IDS } from '../../settings-action-id.constants';
import * as SettingsActions from "../../settings.actions";
import * as Actions from '../evidence-list.actions';
import {TYPES} from "../../settings-action-type.constants";

/**
 * Creates a new EvidenceAddController.
 * @class
 */
class EvidenceAddController {
    constructor($ngRedux, $state, $stateParams, $scope, $rootScope, $filter, AuthService, Notifier) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.stateName = $state.$current.name;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.AuthService = AuthService;
        this.Notifier = Notifier;
    }

    $onInit() {
        this.identifier = IDS.accSettings;
        this.parentState = IDS.app_accreditation_scheme_settings_evidence;

        this.tabState = IDS.app_accreditation_scheme_settings_evidence_add;
        this.title = this.$filter('translate')(`ACCREDITATION.SETTINGS.HOF_REQUIREMENT_EVIDENCE.ADD.TITLE`);
        this.unsubscribe = this.$ngRedux.connect(state => {
            const accSettings = state.accreditation.accSettings;
            return {
                details:        accSettings.evidenceDetails,
                schemeName:     accSettings.frameworkDetails.title,
                sectionName:    accSettings.requirementDetails.nodeName,
                requirement_Id:     accSettings.requirementDetails.id,
                loc_uuid:       accSettings.evidenceGrid.filter.loc_uuid,
                generatorTypes: accSettings.documentGeneratorTypes,
            }
        }, {
            ...SettingsActions,
            ...Actions,
        })(this);

        this.schemeCode = this.$stateParams.itemCode;

        this.$ngRedux.dispatch({
            type:   TYPES.HOF_DOC_DETAILS_REFRESH,
            id:     IDS.accSettings,
            data:  {
                type_code: 'pol', // select first item in document types list
                submission_org_level_code: 'slo',
                generator_type: 'disabled',
                doc_date: new Date(),
                due_date: null,
            }
        });

        if(!this.generatorTypes?.length)
            this.fetchGeneratorTypes();
    }

    onSubmitButton(event) {
        this.$scope.$broadcast('show-errors-check-validity', '$ctrl.hofRequiredDocAddForm');
        if (this.hofRequiredDocAddForm.$invalid || !this.loc_uuid) {
            this.Notifier.error('COMMON.FIELDS_REQUIRED');
            return;
        }
        this.addHeadOfficeEvidenceGroup({
            document_type:  this.details.type_code,
            doc_num:        this.details.doc_num,
            name:           this.details.name,
            description:    this.details.description,
            loc_uuid:       this.loc_uuid,
            ase_id:         this.requirement_Id,
            sample_doc_path: event[0]?.filePath,
            generator_type: this.details.generator_type === 'disabled' ? undefined : this.details.generator_type,
            submission_org_level_code: this.details.submission_org_level_code
        })
    }

    $onDestroy() {
        this.unsubscribe();
    }

}

EvidenceAddController.$inject = ['$ngRedux', '$state', '$stateParams', '$scope', '$rootScope', '$filter', 'AuthService', 'Notifier'];

export const evidenceAdd = {
    controller: EvidenceAddController,
    template: require('./evidence-add.html')
}
